<div class="prosuite-quick-vendor-dialog" role="dialog" aria-labelledby="dialog-title">
  <!-- Header Section -->
  <div class="dialog-header">
    <div class="header-icon" aria-hidden="true">
      <mat-icon class="vendor-icon">store</mat-icon>
    </div>
    <div class="header-content">
      <h2 id="dialog-title" class="dialog-title">Add Vendor</h2>
      <p class="dialog-subtitle">Create a new vendor for this project</p>
    </div>
    <button class="close-btn" (click)="close()" type="button" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content Section -->
  <div class="dialog-content-wrapper">
    <div class="dialog-content" [formGroup]="sectionForm">
      <div class="form-section">
        <div class="form-field-container">
          <label for="name" class="form-label required">
            <mat-icon class="label-icon">business</mat-icon>
            Vendor Name
          </label>
          <input
            type="text"
            id="name"
            formControlName="name"
            class="enhanced-input"
            placeholder="Enter vendor name..."
            [attr.aria-invalid]="sectionForm.get('name')?.invalid && sectionForm.get('name')?.touched">
          <app-validation-error [formGroup]="sectionForm" [controlName]="'name'"></app-validation-error>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Section -->
  <div class="dialog-footer">
    <button
      mat-stroked-button
      (click)="close()"
      class="btn-cancel"
      type="button">
      <mat-icon aria-hidden="true">close</mat-icon>
      Cancel
    </button>
    <button
      mat-raised-button
      (click)="onConfirm()"
      [disabled]="sectionForm.invalid"
      class="btn-submit"
      type="button">
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      Add Vendor
    </button>
  </div>
</div>
